import classNames from "classnames/bind";
import { useEffect, useState, useRef } from "react";
import { Close, DeleteIcon } from "../../../../components/Icons/Icons";
import styles from './ModalAddNotification.module.css';
import PropTypes from 'prop-types'
import image from '../../../../assets/images/Avatar.png'
import { Link } from "react-router-dom";
import { Alert } from "../../../../components";

const cx = classNames.bind(styles);


function ModalAddNotification({ showModal, code, name }) {
    const [isAlert, setIsAlert] = useState(false)
    const boxRef = useRef()
    useEffect(() => {

    }, [])

    const getShowModal = () => {
        showModal()
    }

    const handleDeleteUser = () => {
        setIsAlert(!isAlert)
    }

    const handleClickUser = (code) => {
        sessionStorage.setItem('code', code)
    }

    const handleSubmitDelete = () => {

    }

    useEffect(() => {
        const handleClickOutSide = (e) => {
            if (e.target === boxRef.current) {
                showModal()
            }
        }
        document.body.addEventListener('click', handleClickOutSide)
        return () => {
            document.body.addEventListener('click', handleClickOutSide)
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className={cx('modal-container')} ref={boxRef}>
            {isAlert && <Alert title={'Bạn có muốn xóa người này khỏi thông báo không?'} onOk={handleSubmitDelete} onClose={() => setIsAlert(!isAlert)} />}
            <div className={cx('modal-content')}>
                <div className={cx('header')}>
                    {name === 'user' ? <h1>Danh sách người nhận</h1> : name === 'chanel' ? <h1>Kênh thông báo</h1> : ''}
                    <span className={cx('button-close')} onClick={getShowModal}><Close /></span>
                </div>
                <ul className={cx('body')}>
                    <li className={cx('item-content')}>
                        <p className={cx('index')}>1</p>
                        <img className={cx('user-avatar')} alt={'small avatar'} src={image} />
                        <Link className={cx('user-name')} to={'/admin/user/info-detail'} onClick={() => handleClickUser('20220926000000000002')}>camera</Link>
                        <span className={cx('button-delete')} onClick={handleDeleteUser}><DeleteIcon /></span>
                    </li>
                </ul>
            </div>
        </div>
    )
}

ModalAddNotification.propTypes = {
    showModal: PropTypes.func.isRequired
}

export default ModalAddNotification